<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1a"><a id="page_v"></a><em>This book is for Patricia B</em>.,</p>
<p class="copyright1b"><em>Blue-eyed Nebraska lady</em></p>
<p class="copyright2a"><em>This book honors the memory of Arnold Gingrich</em>.</p>
<p class="copyright2b"><em>Its publication was in part provided for by the</em></p>
<p class="copyright2b"><em>men and women who were his colleagues at</em> Esquire,</p>
<p class="copyright2b"><em>the magazine he founded and edited with distinction</em>.</p>
<p class="noindent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?eb9aa732